import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const CheckDetailSource = {
  get: function({ id, refresh }) {
    return axios.put(`${API_BASE}/seo/${id}`, { refresh }, { catchErrors: false })
      .then(resp => ({ id, result: resp.data, refresh }))
      .catch(error => ({ id, result: error.response.data, refresh }))
  },

  getAdhoc: function(typeId, url) {
    return axios.get(`${API_BASE}/seo/${typeId}?url=${url}`)
      .then(resp => resp.data)
  }
}

export default CheckDetailSource



// WEBPACK FOOTER //
// ./app/sources/CheckDetailSource.js